import { SelectionProps } from "@/interfaces/SelectionProps";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { ArchitectureSearchQueryParameter } from "@/types/ArchitectureSearchQueryParameter";
import RadioTile from "@/components/RadioTile";
import SearchScafold from "@/components/SearchScafold";
import { StructureTypes } from "@/config/StrctureTypes";

const registerKey: keyof ArchitectureSearchQueryParameter = "structure_type_id";
type StructureTypeFormField = Pick<
  ArchitectureSearchQueryParameter,
  "structure_type_id"
>;

const StructureTypeSelection: FC<SelectionProps<StructureTypeFormField>> = ({
  defaultValue,
  onUpdate,
  onBack,
}): JSX.Element => {
  const { register, handleSubmit } = useForm<StructureTypeFormField>();

  return (
    <SearchScafold
      handleSubmit={handleSubmit((data) => {
        onUpdate(data);
        onBack();
      })}
      title={"構造"}
    >
      <ul className="BorderList">
        <li>
          <RadioTile
            value={""}
            register={register(registerKey)}
            label={"指定なし"}
            defaultChecked={!!defaultValue?.structure_type_id}
          />
        </li>

        {StructureTypes.map((structureType) => (
          <li key={structureType.id}>
            <RadioTile
              defaultChecked={defaultValue === structureType.id.toString()}
              value={structureType.id.toString()}
              register={register(registerKey)}
              label={structureType.label}
            />
          </li>
        ))}
      </ul>
    </SearchScafold>
  );
};
export default StructureTypeSelection;
